import {get, set, remove} from "./ls";

export function setAccessToken(token: string) {
    set('@token', token)
}

export function getAccessToken() {
    return get('@token') as string;
}
